module.exports = __webpack_public_path__ + "img/google-icon.09aea0f5.svg";